import * as React from 'react';
import { compose } from 'recompose';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import { BNHIdeaPositionDetailsFooterFragment } from './__generated__/BNHIdeaPositionDetailsFooterFragment';
import { Footer } from 'components/PositionDetailsModal/components/Footer';
import { Factoid } from 'components/PositionDetailsModal/components/Footer/components/Factoid';

export interface Props {
  position?: BNHIdeaPositionDetailsFooterFragment;
}

type Enhanced = Props & InjectedTranslateProps;

const enhance = compose<Enhanced, Props>(translate);

function PositionDetailFooter({ t, position }: Enhanced) {
  if (!position) {
    return null;
  }

  const { totalNetSellAmount, totalBuyAmount } = position;

  return (
    <Footer>
      <Factoid title={t('Debited from the account')} data-testid="transferred-from-account">
        {totalBuyAmount}
      </Factoid>
      <Factoid title={t('Withdrawn to the account')} data-testid="transferred-to-account">
        {totalNetSellAmount}
      </Factoid>
    </Footer>
  );
}

export default enhance(PositionDetailFooter);
